import { Group, Skeleton, Stack } from '@mantine/core';

import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

type SectionSkeletonProps = {
  currentSectionKey?: string;
};

export function SectionSkeleton({ currentSectionKey }: SectionSkeletonProps) {
  const isMobile = useIsMobile();

  const tileHeight = 75;

  if (currentSectionKey === 'finalStep') {
    return <Skeleton h={48} />;
  }

  return (
    <Stack spacing="xl" pt="md" mb="md">
      <Stack spacing="xs">
        <Stack spacing="xs" mb="sm">
          <Skeleton h={isMobile ? 20 : 28} w="50%" />
          <Skeleton h={isMobile ? 20 : 22} w="30%" />
        </Stack>

        <Stack spacing="xs">
          <Group noWrap spacing="xs">
            <Skeleton h={tileHeight} />
            <Skeleton h={tileHeight} />
          </Group>
        </Stack>
      </Stack>
    </Stack>
  );
}
